import { createEffect } from 'effector';

import { KeycloakService } from '@m/keycloak-service/KeycloakService';
import GoogleAuth from '@m/utils/GoogleAuth';
import { heapClearEventProperties, heapIdentityReset } from '@m/utils/heap';
import { apiFetch } from '@m/utils/http';
import { userAnalytics } from '@m/utils/userAnalytics';

let gAuth: GoogleAuth;

export const getCurrentUser = createEffect({
  handler: () => apiFetch('/admin/user'),
});

export const logout = createEffect({
  handler: async () => {
    if (KeycloakService.isLoggedIn()) {
      await KeycloakService.doLogout();
      userAnalytics.unsetUser();
      return { success: true };
    }

    const logoutResp = await apiFetch('/logout', { method: 'POST' });

    if (logoutResp.success) {
      heapIdentityReset();
      heapClearEventProperties();
      userAnalytics.unsetUser();

      if (!gAuth) {
        gAuth = new GoogleAuth();
      }
      await gAuth.logout();
    }

    return logoutResp;
  },
});
